// extracted by mini-css-extract-plugin
module.exports = {"root":"Skeleton_root__zY_ER","shimmer":"Skeleton_shimmer__7dS5L"};